import {flags as rarumFlags} from './rarum.flags'
import {customizer} from 'core/helpers/utils'
import _ from 'lodash'
import { FeatureFlags } from './flags.types'

const tenantFlags: Partial<FeatureFlags> = {}

export const flags = _.assignInWith({...tenantFlags}, {...rarumFlags}, customizer)